import React from 'react'
import { MenuIcon } from '@heroicons/react/outline'
import cubboLogo from '../../assets/cubbo-white.png'

export default function MobileTopBar({ warehouseName, onOpenSidebar }) {
    return (
        <div
            className="flex items-center gap-3 px-4 py-3 lg:hidden flex-shrink-0"
            style={{ backgroundColor: '#DCA118' }}
        >
            <button onClick={onOpenSidebar} aria-label="Open menu">
                <MenuIcon className="w-6 h-6 text-white" />
            </button>
            <img src={cubboLogo} alt="Cubbo" className="w-6 h-6 object-contain" />
            <span className="text-white font-semibold text-sm">Cubbo WMS</span>
            <span className="ml-auto text-white text-xs opacity-80">{warehouseName}</span>
        </div>
    )
}
